import { render, staticRenderFns } from "./scroll_image.vue?vue&type=template&id=42b4f4d9&scoped=true"
import script from "./scroll_image.vue?vue&type=script&lang=js"
export * from "./scroll_image.vue?vue&type=script&lang=js"
import style0 from "./scroll_image.vue?vue&type=style&index=0&id=42b4f4d9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b4f4d9",
  null
  
)

export default component.exports